import { TimetableReportType } from '@bp/planung-graphql-types';
import { Button, Table, TableColumns } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export type TimetableReportTypesTableType = {
  type: TimetableReportType | null;
  name: string;
};

type TimetableReportTypesTableProps = {
  data: TimetableReportTypesTableType[];
  onSelect: (headline: string, type: TimetableReportType | null) => void;
  onConfigModal: () => void;
};

export const TimetableReportTypesTable = ({ data, onSelect, onConfigModal }: TimetableReportTypesTableProps) => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const columns: TableColumns<TimetableReportTypesTableType>[] = [
    {
      header: '',
      id: 'name',
      accessorKey: 'name',
      canExpand: true,
    },
  ];

  return (
    <Table<TimetableReportTypesTableType>
      hideHeader
      data={data}
      columns={columns}
      onRowClick={(e, row) => {
        setSelectedIndex(parseInt(row.id));
        onSelect(row.original.name, row.original.type);
      }}
      showRowHover
      rowSelection={selectedIndex || selectedIndex === 0 ? { [selectedIndex]: true } : undefined}
      showSelected
      customPadding='var(--spacing-6)'
      lastColWidth={'fit-content'}
      lastCol={(row) => {
        return (
          <Button hierarchy={'secondary'} onClick={onConfigModal} disabled={!permissions?.canWriteTimetable()}>
            {t('timetable.configuration.configure')}
          </Button>
        );
      }}
    />
  );
};
